/* This file takes care of passing the jwt to all the routes that needs it */

export const getJwt = () => {
    return localStorage.getItem('token')
};